module.exports = __webpack_public_path__ + "img/9788958286660.db1084da.jpg";